/*
 * Returns default headers list
 * which will be used with every request.
 */
const BASE_HEADERS = {
  'Content-Type': 'application/json',
};

const validStatuses = [
  200, 201, 202, 203, 204,
  300, 301, 302, 303, 304,
  403,
];

export function getHeaders(multipart = false) {
  let defaultHeaders = BASE_HEADERS;

  if (multipart) {
    defaultHeaders = {};
  }

  if (localStorage.token) {
    defaultHeaders = {
      Authorization: `Bearer ${localStorage.token}`,
      ...defaultHeaders,
    };
  }

  return defaultHeaders;
}

/*
 * Wraps error responses from the API
 * and returns `Promise.reject` with error
 */
export function checkResponse(response) {
  if (validStatuses.includes(response.status)) {
    return response;
  }

  // If not authorized then reset token
  // and redirect to login page
  // if (response.status === 401) {
  //   localStorage.removeItem('token');
  //   alert('login needed!');
  //   // router.push('login');
  //
  //   return Promise.reject(new Error('USER_ANONYMOUS'));
  // }

  const err = new Error(response.statusText);
  err.response = response;

  return Promise.reject(err);
}

// Just a convenient shorthand
export const esc = encodeURIComponent;

// Returns formatted query string from object
export function qs(params) {
  return (
    Object
      .keys(params)
      .map(k => `${esc(k)}=${esc(params[k])}`)
      .join('&')
  );
}
